import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { DefaultEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { TrainOfferDateSelectorType } from "../../../Orchestrator/Types/Index";

export class DateSelectorUpdationAction extends BaseAction<void, TrainOfferDateSelectorType> {

    override async run(): Promise<void | null> {
        try {
            const { startIndex, endIndex, dates, selectedDate } = this.params!;

            const selectedIndex = dates.findIndex((d: any) => d.date === selectedDate);
            if (selectedIndex >= 0) {
                // Calculate startIndex to position selected date at index 1 (showing 1 past date)
                let newStartIndex = Math.max(0, selectedIndex - 1);
                
                // Ensure we don't go beyond the available dates
                if (newStartIndex + DefaultEnum.defaultDatesShow > dates.length) {
                    newStartIndex = Math.max(0, dates.length - DefaultEnum.defaultDatesShow);
                }
                
                // Only update if the calculated startIndex is different from current
                if (newStartIndex !== startIndex) {
                    updateRecoilState("startIndexDateSelectorAtom", newStartIndex);
                }
            }
        } catch (error) {
            console.error("Error in DateSelectorUpdationAction:", error);
        }
    }
}

// Create a singleton instance
export const dateSelectorUpdationAction = new DateSelectorUpdationAction(); 